import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";
import { IApplyJobResponse, ICreateFAQResponse, ICustomerQueryResponse, IGetActiveBlogResponse, IGetActiveJobResponse, IGetAJobByJobIdResponse, IGetAllFaqResponse, IGetAllPageResponse, IGetBlogBySlugResponse, IGetByIdFaqResponse, IGetByIdPageResponse, IGetMyJobApplicationResponse } from "../../../types/Response/CustomerResponse";
import { APPLY_JOB, CREATE_QUERY, GET_ACTIVE_BLOGS, GET_ACTIVE_JOB, GET_BLOG_DETAILS, GET_FAQ_ACTIVE, GET_FEATURED_BLOGS, GET_JOB_DETAILS, GET_MY_APPLICATIONS, GET_PAGE, } from "../../../config/apiUrlsCustomer";
import { GetUpdateSortOrderRequest, IApplyJobRequest, ICreateContactRequest, ICreateFAQRequest, ICreatePageRequest, IUpdateAQRequest, IUpdatePageRequest, IUpdatePageStatusRequest } from "../../../types/Request/CustomerRequest";
import { CREATE_FAQ, CREATE_PAGE, DELETE_FAQ, FAQ_GET_ALL, FAQ_UPDATE_SORT_ORDER, GET_FAQ_BY_ID, GET_PAGE_BY_ID, PAGE_GET_ALL, PAGE_UPDATE_STATUS, UPDATE_FAQ, UPDATE_PAGE } from "../../../config/apiUrlsAdmin";

export const customerFooterAPi = createApi({
    reducerPath: "customerFooterAPi",
    baseQuery: axiosBaseQuery(),

    endpoints: (builder) => ({
        ApplyJob: builder.mutation<IApplyJobResponse, IApplyJobRequest>({
            query: (data) => ({
                url: `${APPLY_JOB}`,
                method: "post",
                data: data,
            }),
        }),
        GetActiveJob: builder.query<IGetActiveJobResponse, void>({
            query: (data) => ({
                url: `${GET_ACTIVE_JOB}`,
                method: "get",

            }),
        }),
        GetJobDetails: builder.query<IGetAJobByJobIdResponse, number>({
            query: (id) => ({
                url: `${GET_JOB_DETAILS}/${id}`,
                method: "get",

            }),
        }),
        GetMyApplications: builder.query<IGetMyJobApplicationResponse, void>({
            query: () => ({
                url: `${GET_MY_APPLICATIONS}`,
                method: "get",

            }),
        }),
        GetActiveBlog: builder.query<IGetActiveBlogResponse, void>({
            query: () => ({
                url: `${GET_ACTIVE_BLOGS}`,
                method: "get",

            }),
        }),
        GetJBlogDetailsBySlug: builder.query<IGetBlogBySlugResponse, string>({
            query: (slug) => ({
                url: `${GET_BLOG_DETAILS}/${slug}`,
                method: "get",

            }),
        }),
        GetFeatured: builder.query<IGetActiveBlogResponse, void>({
            query: () => ({
                url: `${GET_FEATURED_BLOGS}`,
                method: "get",

            }),
        }),

       //FAQ//
        GetFaqActive: builder.query<IGetAllFaqResponse, number>({
            query: (category) => ({
                url: `${GET_FAQ_ACTIVE}?category=${category}`,
                method: "get",
            }),
        }),

        ////// page /////
        GetPage: builder.query<IGetByIdPageResponse, number>({
            query: (type) => ({
                url: `${GET_PAGE}?type=${type}`,
                method: "get",
            }),
        }),
        CreateQuery: builder.mutation<ICustomerQueryResponse, ICreateContactRequest>({
            query: (data) => ({
                url: `${CREATE_QUERY}`,
                method: "post",
                data: data,
            }),
        }),

    }),
});

export const { useApplyJobMutation, useLazyGetActiveJobQuery, useLazyGetJobDetailsQuery, useLazyGetMyApplicationsQuery, useLazyGetActiveBlogQuery, useLazyGetFeaturedQuery, useLazyGetJBlogDetailsBySlugQuery, useLazyGetFaqActiveQuery, useLazyGetPageQuery,useCreateQueryMutation } = customerFooterAPi;
